import PropTypes from 'prop-types';
import { classNames } from 'uikit/utils';

// Compact segmented switch for a section header - a lighter replacement of tabs and short dropdowns
const SectionSwitch = ({ options, value, onChange }) => (
  <div className={'repeat-transaction-section-switch'} role={'radiogroup'}>
    {options.map((option) => (
      <button
        key={option.key}
        type={'button'}
        role={'radio'}
        aria-checked={value === option.key}
        className={classNames({
          'repeat-transaction-section-switch-option': true,
          active: value === option.key
        })}
        onClick={() => onChange(option.key)}
      >
        {option.title}
      </button>
    ))}
  </div>
);

SectionSwitch.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default SectionSwitch;
